<template>
  <div class="justSelectForm">
    <div class="justSelectForm__box box1">
      <label for="dishType">Wybierz kategorię</label>
      <select name="dishType"
              id="dishType"
              class="justSelectForm__box__select"
              @change="getDishesFromCategory()"
              v-model="dish.category"
              required>

        <optgroup label="Menu zwykłe">
          <option value="starter">Przystawka</option>
          <option value="soup">Zupa</option>
          <option value="veganDish">Danie wegetariańskie</option>
          <option value="meatDish">Danie mięsne</option>
          <option value="fish">Ryby</option>
          <option value="salad">Sałaty</option>
          <option value="pasta">Pasty</option>
          <option value="dessert">Deser</option>
        </optgroup>

        <optgroup label="Menu dla dzieci">
          <option value="kids">Dla dzieci</option>
        </optgroup>

        <optgroup label="Alkohole">
          <option value="alcohol-wineWhite">Wino białe</option>
          <option value="alcohol-wineRed">Wino czerwone</option>
          <option value="alcohol-wineMuss">Wino musujące</option>
          <option value="alcohol-beer">Piwo</option>
          <option value="alcohol-strong">Mocne alkohole</option>
        </optgroup>

      </select>
    </div>

    <div class="justSelectForm__box box2">
      <label for="dish">Wybierz danie</label>
      <select id="dish"
              class="justSelectForm__box__select"
              @change="exportDataToFillTheForm"
              v-model="dishToFill.name">
        <option v-for="dish in dishes" :value="dish.name">{{ dish.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { db } from '../../firebase'

export default {
  name: 'justSelectForm',
  data () {
    return {
      dish: {
        category: '',
        name: ''
      },
      dishes: [],
      dishToFill: {
        category: '',
        name: ''
      }
    }
  },
  methods: {
    exportDataToFillTheForm () {
      this.$emit('fillForm', this.dishToFill)
    },
    getDishesFromCategory () {
      db.collection("dishes").doc(this.chooseTheRightCategory()).get().then(doc => {
        let objects = doc.data();

        this.clearDishesArray()

        for (let doc in objects) {
          if (objects[doc].type === this.dish.category) this.dishes.push(objects[doc])
        }
      })

      this.completeDataToExport()
    },
    clearDishesArray () {
      this.dishes = [];
    },
    chooseTheRightCategory () {
      if (this.dish.category.includes(`kids`)) return `forKids`
      else if (this.dish.category.includes(`alcohol-`)) return `alcohol`
      else return `normal`
    },
    completeDataToExport () {
      this.dishToFill.category = this.dish.category;
    }
  }
}
</script>

<style lang="scss" scoped>
  .justSelectForm {
    display: none;

    &--visible {
      display: flex;
    }

    &__box {
      display: flex;
      flex-direction: column;

      &__select {
        padding: 10px;
      }
    }
    .box1 {
      margin-right: 20px;
    }
  }
</style>
